<template>
    <app-checker
        :check-app-is-available="true"
        app-name-for-message="Customer Payments"
    >
        <app-main />
    </app-checker>
</template>

<script>
const AppMain = () => import("./components/AppMain");
const AppChecker  = () => import( "@strangeanimals/common-vue-components/src/components/page/AppChecker");

export default {
    name: 'App',
    components: { AppMain, AppChecker },
};
</script>
